"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSubstituteEarningsStatsApiResponseSchema = exports.getSubstituteEarningsStatsItemApiSchema = void 0;
const zod_1 = require("zod");
const api_1 = require("../global/api");
const paginate_list_api_response_schema_1 = require("../global/paginate-list-api-response.schema");
exports.getSubstituteEarningsStatsItemApiSchema = zod_1.z.object({
    id: zod_1.z.string(),
    type: (0, api_1.apiEntityTypeSchema)('substitute-earnings-stats'),
    attributes: zod_1.z.object({
        month: zod_1.z.number(),
        year: zod_1.z.number(),
        confirmedSlots: zod_1.z.number(),
        pendingSlots: zod_1.z.number(),
        averageHonorary: zod_1.z.number(),
        amount: zod_1.z.number(),
    }),
});
exports.getSubstituteEarningsStatsApiResponseSchema = (0, paginate_list_api_response_schema_1.paginteListApiResponseSchema)(exports.getSubstituteEarningsStatsItemApiSchema);
